<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>分类管理</span>
        <div class="header-actions">
          <el-button :loading="loading" @click="loadData">刷新</el-button>
          <el-button type="primary" @click="openCreate">新增分类</el-button>
        </div>
      </div>

      <el-alert
        v-if="loadError"
        class="state-block"
        title="分类数据加载失败"
        type="error"
        :closable="false"
        show-icon
      >
        <template slot>
          <span>可以检查后端服务状态后再重试。</span>
          <el-button type="text" @click="loadData">重新加载</el-button>
        </template>
      </el-alert>

      <template v-else>
        <el-empty v-if="!loading && !list.length" description="还没有分类数据">
          <el-button type="primary" @click="openCreate">去新增</el-button>
        </el-empty>

        <el-table v-else :data="list" border v-loading="loading">
          <el-table-column prop="name" label="分类名称" />
          <el-table-column prop="sort" label="排序" width="100" />
          <el-table-column label="状态" width="120">
            <template slot-scope="{ row }">
              <el-tag :type="row.status ? 'success' : 'info'">{{ row.status ? '启用' : '停用' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="{ row }">
              <el-button type="text" @click="editRow(row)">编辑</el-button>
              <el-button type="text" @click="removeRow(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-card>

    <el-dialog :title="form.id ? '编辑分类' : '新增分类'" :visible.sync="visible" width="480px" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="88px">
        <el-form-item label="名称" prop="name">
          <el-input v-model.trim="form.name" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addCategory, deleteCategory, getCategoryList, updateCategory } from '../../api/admin'

const createForm = () => ({
  id: null,
  name: '',
  parentId: 0,
  sort: 1,
  icon: '',
  status: 1
})

export default {
  data() {
    return {
      list: [],
      loading: false,
      loadError: false,
      visible: false,
      form: createForm(),
      formRules: {
        name: [
          { required: true, message: '请填写分类名称', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请填写排序值', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      this.loadError = false
      try {
        this.list = await getCategoryList()
      } catch (error) {
        this.loadError = true
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.form = createForm()
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
      this.visible = true
    },
    editRow(row) {
      this.form = { ...row }
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
      this.visible = true
    },
    resetForm() {
      this.form = createForm()
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
    },
    async submit() {
      const valid = await new Promise(resolve => {
        this.$refs.formRef.validate(ok => resolve(ok))
      })
      if (!valid) {
        return
      }
      if (this.form.id) {
        await updateCategory(this.form)
      } else {
        await addCategory(this.form)
      }
      this.$message.success('保存成功')
      this.visible = false
      this.loadData()
    },
    removeRow(row) {
      this.$confirm(`确认删除“${row.name}”吗？`, '删除分类', {
        type: 'warning'
      }).then(async () => {
        await deleteCategory(row.id)
        this.$message.success('已删除')
        this.loadData()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.state-block {
  margin-bottom: 16px;
}
</style>
